import { Sizes } from './Dots';

export default class Dot {
  private index: number;

  private currentSlide: number;

  private pageOffset: number;

  constructor({
    index,
    currentSlide,
    pageOffset,
  }: {
    index: number;
    currentSlide: number;
    pageOffset: number;
  }) {
    this.index = index;
    this.currentSlide = currentSlide;
    this.pageOffset = pageOffset;
  }

  get selected(): boolean {
    return this.index === this.currentSlide;
  }

  private get distanceFromSelected(): number {
    return Math.abs(this.index - (1 + this.pageOffset));
  }

  get shown(): boolean {
    return this.distanceFromSelected < 4;
  }

  get size(): Sizes | undefined {
    switch (this.distanceFromSelected) {
      case 0: {
        return Sizes.Large;
      }
      case 1: {
        return Sizes.Large;
      }
      case 2: {
        return Sizes.Medium;
      }
      case 3: {
        return Sizes.Small;
      }
      default:
        return undefined;
    }
  }
}
